import { FaBuilding, FaUserTie, FaMapMarkerAlt, FaIdCard, FaReceipt } from 'react-icons/fa';
import './ImprintPage.css';

function ImprintPage() {
  return (
    <div className="imprint-container">
      <div className="imprint-content">
        <div className="imprint-header"> 
          <h1> Imprint</h1>
        </div>
        
        <div className="imprint-section">
          <h2><FaUserTie /> Service Provider</h2>
          <p>CAE COMPANY<br />Dritero Lushta</p>
        </div>
        
        <div className="imprint-section">
          <h2><FaMapMarkerAlt /> Address</h2>
          <p>Hohenauergasse 8/5<br />1190 Vienna<br />Austria</p>
        </div>
        
        <div className="imprint-section">
          <h2><FaIdCard /> Tax Identification</h2>
          <p>Tax ID: 07 509/5596<br />VAT ID: ATU82460604</p>
        </div>
        
        
      </div>
    </div>
  );
}

export default ImprintPage;